module.exports = __webpack_public_path__ + "static/media/cretto_burri.8baf7888.jpg";